import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

//styles
import { Colors } from "../styles";

const NoResults = ({ text, color }) => {
	return <Text color={color}>{text}</Text>;
};
NoResults.propTypes = {
	text: PropTypes.string,
	color: PropTypes.string,
};

export default NoResults;

const Text = styled.h3`
	position: relative;
	z-index: 2;
	text-align: center;
	color: ${props => props.color ? props.color : Colors.base.white};
`;
